module.exports = "../study/imgs/maps/Kanagawa/S8/Climate/Precipitation/Kanagawa_Precipitation_MIROC5_RCP45_Now.png";